import { CustomScript, CustomScriptResult } from '@signageos/common-types/dist/CustomScript/CustomScript';
import { IScripts } from './IScripts';
import { IFile } from '../fileSystem';

export default class NotImplementedScripts implements IScripts {
	execute(_script: CustomScript, _config: Record<string, any>, _iframeId?: string, _customScriptFile?: IFile): Promise<CustomScriptResult> {
		throw new Error('Method not implemented.');
	}
}
